var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"finish"}},[_c('div',[_vm._m(0),_c('p',[_vm._v(_vm._s(_vm.lang.msg_err_url))]),_c('h4',[_vm._v(_vm._s(_vm.lang.try_again))])]),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/image/rateLev_3.svg")}})])
}]

export { render, staticRenderFns }